/* eslint-disable jsx-a11y/control-has-associated-label */

import React from 'react';
import pt from 'prop-types';

import { contentCollectionLabel } from 'utils/content';

import { Field } from 'components/form';
import SidebarPanel from 'components/storefront/editor/widgets/sidebar-panel';

const SIDEBAR_PANEL_ANIMATION_DURATION = 150;

export default class SwellLookupPanel extends React.PureComponent {
  static propTypes = {
    field: pt.object.isRequired,
    lookup: pt.object.isRequired,
    collection: pt.string.isRequired,
    onChange: pt.func.isRequired,
    onSave: pt.func.isRequired,
    onCancel: pt.func.isRequired,
    onClose: pt.func.isRequired,
    onQuery: pt.func,
    onClickNew: pt.func,
    value: pt.any,
    record: pt.object,
    placeholder: pt.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
      collectionLabel: contentCollectionLabel(props.collection),
    };
    this.lookupRef = React.createRef();
  }

  static getDerivedStateFromProps(props, state) {
    if (props.value !== state.value) {
      return { value: props.value };
    }

    return null;
  }

  componentDidMount() {
    this.focusLookup();
  }

  focusLookup() {
    setTimeout(() => {
      this.lookupRef.current?.focus();
    }, SIDEBAR_PANEL_ANIMATION_DURATION);
  }

  onSave = () => {
    this.props.onSave();
  };

  onCancel = () => {
    this.props.onCancel();
  };

  onClose = () => {
    this.props.onClose();
  };

  onChangeSearch = (_event, record) => {
    const exRecord = this.props.record || null;
    const newRecord = record || null;
    if (exRecord !== newRecord) {
      this.props.onChange(newRecord);
    }
  };

  render() {
    const {
      record,
      field,
      collection,
      lookup,
      placeholder,
      onQuery,
      onClickNew,
    } = this.props;
    const { collectionLabel } = this.state;

    return (
      <SidebarPanel
        title={field.label}
        onSave={this.onSave}
        onCancel={this.onCancel}
        onClose={this.onClose}
        onClickNew={onClickNew}
        value={this.state.value}
        className="storefront-editor--lookup-panel"
      >
        <div className="storefront-editor-widget">
          <Field
            ref={this.lookupRef}
            type="lookup"
            placeholder={placeholder || `Search ${collectionLabel}`}
            select={true}
            model={collection}
            lookup={lookup}
            onChange={this.onChangeSearch}
            defaultValue={record}
            onQuery={onQuery}
            mountQuery={true}
          />
        </div>
      </SidebarPanel>
    );
  }
}
